import { Typography } from 'antd';
import React from 'react';
import FeaturedBannerLists from '../components/FeaturedBannerList';

const { Title } = Typography;

const FeaturedBanner: React.FC = () => (
  <div>
    <Title level={4} style={{ fontWeight: 'bold' }}>Featured</Title>
    <div style={{
      marginTop: 32,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}
    />
    <FeaturedBannerLists />
  </div>
);

export default FeaturedBanner;
